import { SVGProps } from 'react'

export const SizeSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.625 13.25A1.875 1.875 0 0 1 .75 11.375v-8.75C.75 1.589 1.59.75 2.625.75h2.5C6.161.75 7 1.59 7 2.625v3.75c0 .345.28.625.625.625h3.75c1.025 0 1.858.823 1.875 1.844v2.531c0 1.036-.84 1.875-1.875 1.875ZM5.125 2h-2.5A.625.625 0 0 0 2 2.625V3.75h1.25a.563.563 0 0 1 0 1.125H2v1.75h2.063a.563.563 0 0 1 0 1.125H2V9.5h1.25a.562.562 0 1 1 0 1.125H2v.75c0 .314.231.574.533.618l.092.007h3.187v-1.75a.562.562 0 1 1 1.125 0V12h1.875v-1.063a.562.562 0 1 1 1.126 0L9.937 12h1.438a.625.625 0 0 0 .618-.533l.007-.092v-2.5a.625.625 0 0 0-.625-.625H7c-.69 0-1.25-.56-1.25-1.25V2.625A.625.625 0 0 0 5.125 2Z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  )
}
